<template>

  <div class=" good_swiper mt-10">
    <!-- <div class="customClass">123</div> -->
    <el-row class=" el_row " type="flex" justify="start" style="">
      <el-col style="width: 180px" class="box_shadow">
        <div class="shipping-icon flex-col">
          <div class="img_banner">
            <img :style="customStyle" :src="bannerImg || require(`@/assets/images/deflault_load.png`)"
              style="object-fit: contain;"></img>
          </div>
          <!-- <img class=""
            src="https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyhad0ad68af7454206ab604ffe74468b64凯伦格.jpg"
            style="object-fit: fill;"></img> -->
          <div class="flex-row icon_bot ">
            <div class="b_title " v-if="title_img"><img  class="" :src="title_img" style="object-fit: contain;"></img>
            </div>
            <div   :class=" lang == 'zh'?'b_textCH fs-18 ml-5':'b_textEG fs-18 ml-5'">
              <div>{{ $t(title) }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col style="width: 1010px;" class="box_shadow ml-10">
        <div class="shipping-text">
          <div class="swiper-container">
            <div class="swiper-wrapper pl-30 ">
              <div v-if="goodsList.length <= 0" style="line-height: 200px;margin: 0 auto;color:#c3c3c3;">暂无数据</div>
              <div v-else class="flex-col swiper-slide" v-for="(item, index) in goodsList" :key="index"
                @click="click_item(item)">
                <!-- <div style="width: 200px;" :class="title_img ? '' : 'bor'"> -->
                  <div style="width: 200px;" class="title_img">
                  <div class="swiper-img">
                    <img style="width: 100%; height: 100% ;object-fit: scale-down;" :src="item.img[0] || ''" />
                  </div>
                  <div class="protitle fs-15">
                    <!-- {{ lang == 'zh'?item.cname:item.ename || item.companyName }} -->
                      {{ item.title }}
                  </div>
                </div>
              </div>

            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入

export default {
  // 父组件传值
  props: {
    goodsList: {
      type: Array,
      required: true,
    },
    // '../../assets/images/deflault_load.png'
    bannerImg: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    title_img: {
      type: String,
    },
    // 自定义样式
    customStyle: {
      type: Object,
      default: () => ({}),
    },
    // 判断是搜索企业库还是商品库  0：是商品 1：是企业
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedIndex: null,
      lang: "",
    };
  },
  activated() {},
  computed: {
    imageSrc() {
      // 如果 bannerImg 为空字符串，则返回默认图片路径
      return this.bannerImg || "../../assets/images/default_load.png";
    },
  },
  mounted() {
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
    this.getSwiper();
  },
  methods: {
    selectItem(index) {
      this.selectedIndex = index;
    },
    // 初始化轮播图
    getSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        autoplay: {
          //自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        slidesPerView: 4, // 一组三个
        spaceBetween: 30, // 间隔

        preloadImages: false,

        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
        observer: true,
        observeParents: true,
      });
    },

    // 商品点击
    click_item(item) {
      this.$router.push({
        path: ["/shop", "/company"][this.type],
        query: item,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/* pageFullScreen在index.css */

.good_swiper {
  width: 1200px;
  height: 296px;

  .el_row {
    display: flex;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
    margin: 0 !important;

    .shipping-icon {
      /* background-color: white; */
      position: relative;
      overflow: hidden;
      height: 100%;
      width: 100%;
      text-align: center;
      background-color: white;

      .img_banner {
        width: 100%;
        height: 80%;
        justify-content: center;
        align-items: center;
        justify-items: center;
        display: flex;

        img {
          height: 100%;
          width: 100%;
        }
      }

      .icon_bot {
        width: 100%;
        height: 20%;

        .b_title {
          width: 80px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .b_textCH {
          width: 100%;
          color: #24a2ff;
          font-weight: bolder;
          height: 100%;
          align-items: center;
          display: flex;
          justify-content: center;
        }
        .b_textEG {
            width: 100%;
            color: #24a2ff;
            font-weight: bolder;
            height: 100%;
            align-items: center;
            display: flex;
            text-align: left;  
          }
      }

      .imgTitle {
        height: 100%;
        width: 100%;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }

    .shipping-text {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      background: white;
      min-height: 253px !important;

      .swiper-slide {
        /* 商品样式 */
        .swiper-img {
          position: relative;
          width: 170px;
          height: 190px;
          margin: 10px auto;
          padding: 10px;
        }

        .protitle {
          text-align: center;
        }
      }
    }
  }

  .selected {
    color: #409eff;
  }
}

.swiper-button-prev,
.swiper-button-next {
  --swiper-navigation-size: 25px;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  color: rgb(51, 51, 51);
}

.floating-image {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* 添加过渡效果 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  /* 阴影效果 */
}

/* 鼠标悬停时的浮空效果 */
.floating-image:hover {
  transform: translateY(-10px);
  /* 向上移动10px */
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  /* 加强阴影 */
}

.floating-image1 {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* 添加过渡效果 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  /* 阴影效果 */
}

.bor {
  border: 1px solid #d3d3d3;
}
</style>
